import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';

export const checkInstallmentsCount = (InstallmentsCountByDefault: number) =>
  createNormalizeCheckingNumber(
    `Installments count argument is not a number. Tabby widget will be use a default price value ${InstallmentsCountByDefault}`,
    InstallmentsCountByDefault
  );
